import classes from '../../index.module.scss'
import { KEYS_FIELD_LIST, LEFT_FIELDS } from '../constants'
import { InputUserProfile } from './InputUserProfile'
import { JobTitleSelection } from './JobTitleSelection'

export const LeftFields = ({
  isValid,
  onChange,
  form,
  setJobTitle,
  jobTitlesList,
  activeJobTitle,
}) => {
  return (
    <div className={classes.formContent}>
      {LEFT_FIELDS.slice(0, 4).map((item) => (
        <div key={item.key}>
          <InputUserProfile
            title={item.title}
            containerStyle={{
              height: 28,
            }}
            isValid={isValid[item.key]}
            textInvalid={'userProfile.REQUIRED_FIELD'}
            onChange={(e) => onChange(item.key, e, item.isRequired)}
            value={form[item.key]}
            disabled={item.isDisable}
            inputKey={item.key}
          />
        </div>
      ))}

      <InputUserProfile
        title="userProfile.PHONE"
        containerStyle={{
          height: 28,
        }}
        isValid={isValid[KEYS_FIELD_LIST.PHONE]}
        textInvalid={
          typeof form[KEYS_FIELD_LIST.PHONE] === 'string' &&
          !!form[KEYS_FIELD_LIST.PHONE].trim()
            ? 'domesticSearchPreview.INVALID_PHONE'
            : 'userProfile.REQUIRED_FIELD'
        }
        onChange={(e) => onChange(KEYS_FIELD_LIST.PHONE, e, true)}
        value={form[KEYS_FIELD_LIST.PHONE]}
        inputKey={KEYS_FIELD_LIST.PHONE}
      />

      <JobTitleSelection
        activeJobTitle={activeJobTitle}
        setJobTitle={setJobTitle}
        jobTitlesList={jobTitlesList}
      />

      <InputUserProfile
        title="userProfile.ACCOUNT_TYPE"
        containerStyle={{
          height: 28,
        }}
        textInvalid={'userProfile.REQUIRED_FIELD'}
        isValid={isValid[KEYS_FIELD_LIST.ACCOUNT_TYPE]}
        onChange={(e) => onChange(KEYS_FIELD_LIST.ACCOUNT_TYPE, e)}
        value={form[KEYS_FIELD_LIST.ACCOUNT_TYPE]}
        inputKey={KEYS_FIELD_LIST.ACCOUNT_TYPE}
      />
    </div>
  )
}
